import { compose } from 'recompose'; // @ts-expect-error

import { withFocusProps, withHoverProps, withKeyboardFocusProps, withPressedProps } from '@klarna/higher-order-components';
export default (function (_ref) {
  var keyboardFocus = _ref.keyboardFocus;
  return compose(keyboardFocus === true ? withKeyboardFocusProps({
    keyboardFocused: true
  }) : withFocusProps({
    focused: true
  }), withHoverProps({
    hovered: true
  }), withPressedProps({
    pressed: true
  }));
});
//# sourceMappingURL=index.js.map